/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![LettersIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB00lEQVR4nO1TPWgUURBe/5CgKIYE0VKwMoWghQSSqy4u3M7PBuZmdmOhzRUWQhqbQC5F0ghC4NIJNiEEQ5pAGu20Ei0stLCy0EZiaREUjfJ23+kSdy3CNiEZGHbf7sz3zXwzLwgO7eAasCXA2iHSsdrBW5PpJWTbQbZfyPYhCIIjtRIA2bwDB9KfGQm2x2sD73a7R4HtY05gi9mT7XFtBBHrRA6qL0ORYSD9DmRfReT07tg4nrqArDPIuo6ky0B2PwynzvyXAMhWM1liu5efddPLdKcYR5RedcS+02/9mQHbexEZKAVvtdJzSLoNZD8A7HwOpKlPfFGM7XQ6J4BtBVijMAxPRlEyBKxvXKzLKZeHkrtZtWRP+9+azVunfKU7rcnkclleo9E4jmgXkayXb57OlhIg2Ssf8A7J1gq+5Vd2YVdBjKTPXMf+f+ZuC/+VJ26PFIPKHEg/icixXLoEfDGfEW2aSEeB7EElAZA99NuzwZxeKzqiXe93QdS+mcWzPvKkt/9i6FIpgRtYVklOEFXI18vno0+yM+usH/5zR+LWtFIiYCXf7hdHVkYAcfuGJ9gWkUEROQusr/9ISPYWSOcqJdrzrQe74u6Ee68F9ND2n/0Gzk/9U/mSBoAAAAAASUVORK5CYII=)
 */
export const LettersIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M13.23 18h-2.27l-.99-2.77H4.75L3.76 18H1.5L6.21 5.58h2.3L13.23 18ZM7.36 7.87 5.44 13.3h3.85L7.36 7.87ZM17 18.25c-.75 0-1.38-.22-1.88-.66a2.36 2.36 0 0 1-.76-1.88c0-1.9 1.73-2.86 5.18-2.9v-.25c0-.51-.15-.91-.45-1.2-.3-.29-.72-.43-1.26-.43a3.55 3.55 0 0 0-2.3.97l-.97-1.24c.4-.44.9-.77 1.5-1.01a4.95 4.95 0 0 1 1.88-.36c2.4 0 3.58 1.09 3.58 3.27V18h-1.81l-.17-1.06a3.01 3.01 0 0 1-2.53 1.31Zm.51-1.58c.78 0 1.46-.38 2.03-1.14v-1.4c-1.1.04-1.92.18-2.44.43-.53.24-.8.6-.8 1.06 0 .34.11.6.33.78.21.18.5.27.88.27Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
